import { Fragment } from "react"
import { Box, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { StandardDialog } from "../../../../../../../shared/components/dialogs/StandardDialog"
import { LocalizedEnum, LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { OrganizerDetails } from "../../meetingServiceTypes"

const useStyles = makeStyles()((theme) => ({
    dialogBody: {
        padding: "1rem 2rem 2rem",
    },
    role: {
        fontWeight: 600,
        color: theme.palette.tailwind.slate[700],
    },
    detailsGrid: {
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        columnGap: ".5rem",
        rowGap: ".25rem",
        alignItems: "start",
    },
    label: {
        color: theme.palette.tailwind.slate[500],
    },
}))

type Props = Readonly<{
    open: boolean
    onClose: () => void
    organizers: ReadonlyArray<OrganizerDetails>
}>

export function ProductionOrderUsersDialog({ open, onClose, organizers }: Props) {
    const { classes } = useStyles()

    return (
        <StandardDialog
            open={open}
            onClose={onClose}
            maxWidthProp="sm"
            dialogTitle={
                <LocalizedStrict id="meeting-service-production-view-users-dialog-title">
                    <>Contact details</>
                </LocalizedStrict>
            }
        >
            <Stack spacing="1.5rem" className={classes.dialogBody}>
                {organizers.map((organizer, index) => {
                    const phone = organizer.mobileNumber ?? organizer.phoneNumber
                    return (
                        <Stack key={`${organizer.type}-${index}`} spacing=".5rem">
                            <LocalizedEnum
                                base="meeting-service-production-view-organizer-type"
                                enumValue={organizer.type}
                            >
                                <Typography variant="subtitle1" className={classes.role}>
                                    {organizer.type}
                                </Typography>
                            </LocalizedEnum>
                            <Box className={classes.detailsGrid}>
                                <LocalizedStrict id="meeting-service-production-view-users-dialog-name-label">
                                    <Typography className={classes.label}>Name:</Typography>
                                </LocalizedStrict>
                                <Typography>{organizer.name}</Typography>
                                {organizer.email && (
                                    <Fragment>
                                        <LocalizedStrict id="meeting-service-production-view-users-dialog-email-label">
                                            <Typography className={classes.label}>Email:</Typography>
                                        </LocalizedStrict>
                                        <Typography>{organizer.email}</Typography>
                                    </Fragment>
                                )}
                                {phone && (
                                    <Fragment>
                                        <LocalizedStrict id="meeting-service-production-view-users-dialog-phone-label">
                                            <Typography className={classes.label}>Phone:</Typography>
                                        </LocalizedStrict>
                                        <Typography>{phone}</Typography>
                                    </Fragment>
                                )}
                            </Box>
                        </Stack>
                    )
                })}
            </Stack>
        </StandardDialog>
    )
}
